import { Component } from "react";
import SignatureCanvas from "react-signature-canvas-react17-compatible";
import "./Signature.css";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import IconButton from "@mui/material/IconButton";
import ReplayIcon from "@mui/icons-material/Replay";
import ValidateIcon from "@mui/icons-material/Check";
import { withStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import { ImageListItem, ImageListItemBar } from "@mui/material";

const styles = {
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class Signature extends Component {
    constructor(props) {
        super(props);
        this.props.onRef(this);

        this.state = {
            editionMode: false,
            sizeOptions: { ratio: 1, width: 240, height: 240 },
        };
    }

    componentDidMount() {
        if (this.props.currentSignature !== null) {
            this.preview.clear();
            this.preview.fromDataURL(this.props.currentSignature, this.state.sizeOptions);
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    validate() {
        let signature;

        if (this.signatureEdition.isEmpty()) {
            signature = undefined;
            this.preview.clear();
        } else {
            signature = this.signatureEdition.getTrimmedCanvas().toDataURL();
            this.preview.clear();
            this.preview.fromDataURL(signature, this.state.sizeOptions);
        }

        this.props.onValidateSignature(signature);
    }

    clear() {
        this.signatureEdition.clear();
    }

    close() {
        this.props.close();
    }

    editSignature() {
        this.props.open();
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <div className="div-center row without-side-padding" onClick={this.editSignature.bind(this)}>
                    <ImageListItem
                        className="signature-grid-tile"
                        sx={{
                            padding: 0,
                        }}
                    >
                        <div className="signature-auto-size">
                            <SignatureCanvas
                                penColor="black"
                                ref={(ref) => {
                                    this.preview = ref;
                                }}
                                canvasProps={{
                                    width: 240,
                                    height: 240,
                                    className: "disabled signature-bloc minify-signature",
                                }}
                            />

                            <ImageListItemBar
                                title={this.props.label}
                                actionIcon={
                                    <IconButton onClick={this.editSignature.bind(this)}>
                                        <EditIcon className="white-icon" />
                                    </IconButton>
                                }
                            />
                        </div>
                    </ImageListItem>
                </div>
                <Dialog
                    aria-labelledby="simple-dialog-title"
                    open={this.props.editionMode}
                    onClose={this.close.bind(this)}
                    fullScreen
                >
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                Signature
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Toolbar />
                    <DialogContent className="container without-side-padding">
                        <SignatureCanvas
                            penColor="black"
                            ref={(ref) => {
                                this.signatureEdition = ref;
                            }}
                            canvasProps={{
                                className: "signature-bloc edit-signature-bloc",
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <IconButton onClick={this.clear.bind(this)}>
                                <ReplayIcon />
                            </IconButton>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6 right without-side-padding">
                            <IconButton onClick={this.validate.bind(this)}>
                                <ValidateIcon />
                            </IconButton>
                        </div>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles)(Signature);
